module.exports = __webpack_public_path__ + "static/img/08.dd2631d6.jpg";